module.exports = __webpack_public_path__ + "01_glasses_black.d554e926.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer4/01_glasses_black.png
// module id = zAo2
// module chunks = 0